import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { compareTo3ankvs086tmwq as compareTo_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _Name___init__impl__o4q07e(raw) {
  return raw;
}
function _Name___get_raw__impl__1jq1il($this) {
  return $this;
}
function Name__toString_impl_61tomu($this) {
  return _Name___get_raw__impl__1jq1il($this);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.lightningserver.notifications.events.EventType.Name', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_5z6qw9_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeString_424b5v_k$(_Name___get_raw__impl__1jq1il(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_5z6qw9_k$(encoder, value instanceof Name() ? value.raw_1 : THROW_CCE());
      }
      deserialize_dei0c0_k$(decoder) {
        return _Name___init__impl__o4q07e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Name())(this.deserialize_dei0c0_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Name__hashCode_impl_fpc861($this) {
  return getStringHashCode($this);
}
function Name__equals_impl_uazebh($this, other) {
  if (!(other instanceof Name()))
    return false;
  if (!($this === other.raw_1))
    return false;
  return true;
}
function Name__compareTo_impl_4jtsrs($this, other) {
  return $this.compareTo_44yzl0_k$(new (Name())(other instanceof Name() ? other.raw_1 : THROW_CCE()));
}
function EventType$Companion$$childSerializers$_anonymous__melmyy() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var NameClass;
function Name() {
  if (NameClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _Name___get_raw__impl__1jq1il(this.raw_1);
      }
      toString() {
        return Name__toString_impl_61tomu(this.raw_1);
      }
      hashCode() {
        return Name__hashCode_impl_fpc861(this.raw_1);
      }
      equals(other) {
        return Name__equals_impl_uazebh(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Name__compareTo_impl_4jtsrs(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'Name', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance});
    NameClass = $;
  }
  return NameClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, EventType$Companion$$childSerializers$_anonymous__melmyy)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.events.EventType', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('tags', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_45elva_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance(), new (Name())(value.name_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !equals(value.tags_1, emptySet())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.tags_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_45elva_k$(encoder, value instanceof EventType() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (Name())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (Name())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EventType().new_com_lightningkite_lightningserver_notifications_events_EventType_93c43o_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var EventTypeClass;
function EventType() {
  if (EventTypeClass === VOID) {
    class $ {
      constructor(name, tags) {
        Companion_getInstance_0();
        tags = tags === VOID ? emptySet() : tags;
        this.name_1 = name;
        this.tags_1 = tags;
      }
      equals(other) {
        var tmp;
        if (other instanceof EventType()) {
          tmp = this.name_1 === other.name_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return Name__hashCode_impl_fpc861(this.name_1) + 17 | 0;
      }
      toString() {
        return 'EventType(name=' + Name__toString_impl_61tomu(this.name_1) + ', tags=' + toString(this.tags_1) + ')';
      }
      static new_com_lightningkite_lightningserver_notifications_events_EventType_93c43o_k$(seen0, name, tags, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.name_1 = name;
        if (0 === (seen0 & 2))
          $this.tags_1 = emptySet();
        else
          $this.tags_1 = tags;
        return $this;
      }
    }
    initMetadataForClass($, 'EventType', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    EventTypeClass = $;
  }
  return EventTypeClass;
}
function _IdJsonEncoded___init__impl__qtxwoi(rawJson) {
  return rawJson;
}
function _IdJsonEncoded___get_rawJson__impl__vinh5v($this) {
  return $this;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.lightningserver.notifications.events.EventData.IdJsonEncoded', this);
        tmp0_serialDesc.addElement_5pzumi_k$('rawJson', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8jhvcn_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeString_424b5v_k$(_IdJsonEncoded___get_rawJson__impl__vinh5v(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8jhvcn_k$(encoder, value instanceof IdJsonEncoded() ? value.rawJson_1 : THROW_CCE());
      }
      deserialize_a2nxy_k$(decoder) {
        return _IdJsonEncoded___init__impl__qtxwoi(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (IdJsonEncoded())(this.deserialize_a2nxy_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function IdJsonEncoded__toString_impl_98adyi($this) {
  return 'IdJsonEncoded(rawJson=' + $this + ')';
}
function IdJsonEncoded__hashCode_impl_uzgard($this) {
  return getStringHashCode($this);
}
function IdJsonEncoded__equals_impl_cfmct9($this, other) {
  if (!(other instanceof IdJsonEncoded()))
    return false;
  if (!($this === other.rawJson_1))
    return false;
  return true;
}
var IdJsonEncodedClass;
function IdJsonEncoded() {
  if (IdJsonEncodedClass === VOID) {
    class $ {
      constructor(rawJson) {
        this.rawJson_1 = rawJson;
      }
      toString() {
        return IdJsonEncoded__toString_impl_98adyi(this.rawJson_1);
      }
      hashCode() {
        return IdJsonEncoded__hashCode_impl_uzgard(this.rawJson_1);
      }
      equals(other) {
        return IdJsonEncoded__equals_impl_cfmct9(this.rawJson_1, other);
      }
    }
    initMetadataForClass($, 'IdJsonEncoded', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    IdJsonEncodedClass = $;
  }
  return IdJsonEncodedClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.events.EventData', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('timestamp', false);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('subject', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_1tntn2_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value._id_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, InstantSerializer_getInstance(), value.timestamp_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_0(), value.type_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, $serializer_getInstance_1(), new (IdJsonEncoded())(value.subject_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1tntn2_k$(encoder, value instanceof EventData() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance_1();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (IdJsonEncoded())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.rawJson_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_2 = $serializer_getInstance_1();
                var tmp_3 = tmp7_local3;
                var tmp_4 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (IdJsonEncoded())(tmp_3));
                tmp7_local3 = tmp_4 == null ? null : tmp_4.rawJson_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EventData().new_com_lightningkite_lightningserver_notifications_events_EventData_22sadz_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), InstantSerializer_getInstance(), $serializer_getInstance_0(), $serializer_getInstance_1()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var EventDataClass;
function EventData() {
  if (EventDataClass === VOID) {
    class $ {
      constructor(_id, timestamp, type, subject) {
        this._id_1 = _id;
        this.timestamp_1 = timestamp;
        this.type_1 = type;
        this.subject_1 = subject;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        return 'EventData(_id=' + this._id_1.toString() + ', timestamp=' + this.timestamp_1.toString() + ', type=' + this.type_1.toString() + ', subject=' + IdJsonEncoded__toString_impl_98adyi(this.subject_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + this.timestamp_1.hashCode() | 0;
        result = imul(result, 31) + this.type_1.hashCode() | 0;
        result = imul(result, 31) + IdJsonEncoded__hashCode_impl_uzgard(this.subject_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EventData()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!this.timestamp_1.equals(other.timestamp_1))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        if (!(this.subject_1 === other.subject_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_events_EventData_22sadz_k$(seen0, _id, timestamp, type, subject, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this._id_1 = _id;
        $this.timestamp_1 = timestamp;
        $this.type_1 = type;
        $this.subject_1 = subject;
        return $this;
      }
    }
    initMetadataForClass($, 'EventData', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_2});
    EventDataClass = $;
  }
  return EventDataClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.events.UserEventType', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('user', false);
        tmp0_serialDesc.addElement_5pzumi_k$('event', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_rzxuna_k$(typeSerial0) {
        return $serializer_3().new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_rzxuna_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_4rda3u_k$();
      }
      static new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_4rda3u_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.events.UserEventType', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('user', false);
        tmp0_serialDesc.addElement_5pzumi_k$('event', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_dzg35y_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, this.typeSerial0__1, value.user_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), new (Name())(value.event_1));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dzg35y_k$(encoder, value instanceof UserEventType() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (Name())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp5_local1;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (Name())(tmp_3));
                tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return UserEventType().new_com_lightningkite_lightningserver_notifications_events_UserEventType_6t30tg_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, $serializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_4rda3u_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var UserEventTypeClass;
function UserEventType() {
  if (UserEventTypeClass === VOID) {
    class $ {
      constructor(user, event) {
        Companion_getInstance_3();
        this.user_1 = user;
        this.event_1 = event;
      }
      compareTo_ktzjnt_k$(other) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = compareTo_0(this.user_1, other.user_1);
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? (new (Name())(this.event_1)).compareTo_44yzl0_k$(new (Name())(other.event_1)) : tmp0_elvis_lhs;
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_ktzjnt_k$(other instanceof UserEventType() ? other : THROW_CCE());
      }
      toString() {
        return 'UserEventType(user=' + toString(this.user_1) + ', event=' + Name__toString_impl_61tomu(this.event_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.user_1);
        result = imul(result, 31) + Name__hashCode_impl_fpc861(this.event_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UserEventType()))
          return false;
        if (!equals(this.user_1, other.user_1))
          return false;
        if (!(this.event_1 === other.event_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_events_UserEventType_6t30tg_k$(seen0, user, event, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_3().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.user_1 = user;
        $this.event_1 = event;
        return $this;
      }
    }
    initMetadataForClass($, 'UserEventType', VOID, VOID, [Comparable()], VOID, VOID, {0: Companion_getInstance_3});
    UserEventTypeClass = $;
  }
  return UserEventTypeClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  $serializer_3 as $serializer1poubtr9zukuj,
  UserEventType as UserEventType9fgr3eoymf06,
  _Name___get_raw__impl__1jq1il as _Name___get_raw__impl__1jq1il10anje4t2nwc9,
  $serializer_getInstance_2 as $serializer_getInstancee9uv99qo59n5,
  Companion_getInstance_3 as Companion_getInstance2j1uv91l5kue6,
};
//endregion

//# sourceMappingURL=eventModels.mjs.map
